import * as moment from "moment";

export function humanDateFilter(date) {
    moment.locale('es');
    return (date !== null && date !== '' && date != undefined) ? moment(date).format("D MMM Y HH:mm") : null;
};

export function humanDateFilter2(date) {
    moment.locale('es');
    return (date !== null && date !== '' && date !== undefined) ? moment(date).format("D MMM Y") : null;
}
